import { useState, useRef, useEffect, useContext } from 'react';
import { Storage } from 'aws-amplify';
import { generateUUID } from '../../utils/uid';
import HttpAxios from '../../hooks/http';
import enviroment from '../../../enviroments/enviroment';
import { useUserMe } from '../../hooks/userme';
import { AppContext } from '../../context/App-context';
import { ESuccessMsg } from '../../statics/controls';
import { IUserMe } from '../../interfaces/user';
import IconAttach from '../../../images/attach.svg';
import IconClose from '../../../images/close-blue.svg';
import './upload.scss';

type TUpload = 'video' | 'doc';

interface IUpload {
    type: TUpload;
}

const Upload = (props: IUpload) => {
    const { type } = props;
    const [userMe, setUserMe] = useUserMe();
    const [selectedFile, setSelectedFile] = useState<any>();
    const { changeIsLoading, changeSnackBar } = useContext(AppContext);
    const [msgError, setMsgError] = useState<string>('');
    const [isSelected, setIsSelected] = useState(false);
    const [progress, setProgress] = useState(0);
    const [nameUploaded, setNameUploaded] = useState('');
    const [uploaded, setUploaded] = useState<boolean>(false);
    const fileInput = useRef<any>(null);
    const changeHandler = (event: any) => {
        setSelectedFile(event?.target?.files[0]);
        setIsSelected(true);
    };

    const handleSubmission = async () => {
        setProgress(0);
        setNameUploaded('');
        setUploaded(false);
        setMsgError('');

        if (
            selectedFile?.size <=
                enviroment.limitUpload[IsVideo() ? 'video' : 'doc'] &&
            (IsVideo()
                ? enviroment.limitUpload.videoAllow.indexOf(
                      selectedFile?.type?.toLowerCase()
                  ) > -1
                : enviroment.limitUpload.docAllow.indexOf(
                      (selectedFile?.name || '').split('.').pop()
                  ) > -1)
        ) {
            const fileName =
                generateUUID() +
                '.' +
                (selectedFile?.name || '').split('.').pop();
            setProgress(0.25);
            setNameUploaded(fileName);

            try {
                await Storage.put(fileName, selectedFile, {
                    contentType: selectedFile?.type,
                    progressCallback(progress: any) {
                        const { loaded, total } = progress;
                        setProgress((loaded / total) * 100);
                    },
                })
                    .then(() => {
                        const filePath = enviroment.storageURL + fileName;
                        saveUploaded(filePath, () => {
                            let userMeUpdated = (userMe as IUserMe) || {};
                            userMeUpdated[
                                IsVideo() ? 'urlvideo' : 'urldeclaracionjurada'
                            ] = filePath;
                            setUserMe({ ...userMeUpdated });
                            setProgress(100);
                            setUploaded(true);
                            changeSnackBar(ESuccessMsg.snackBar);
                            resetInputFile();
                        });
                    })
                    .catch(() => {
                        setMsgError(enviroment.limitUpload.errorGeneric);
                        setProgress(0);
                        setSelectedFile(undefined);
                        setIsSelected(false);
                        setUploaded(false);
                        resetInputFile();
                    });
            } catch (err) {
                setMsgError(enviroment.limitUpload.errorGeneric);
                setProgress(0);
                setSelectedFile(undefined);
                setIsSelected(false);
                setUploaded(false);
                resetInputFile();
            }
        } else {
            if (
                selectedFile?.size >
                enviroment.limitUpload[IsVideo() ? 'video' : 'doc']
            ) {
                setMsgError(
                    enviroment.limitUpload[
                        IsVideo() ? 'videoErrorWeight' : 'docErrorWeight'
                    ]
                );
            } else if (
                enviroment.limitUpload[
                    IsVideo() ? 'videoAllow' : 'docAllow'
                ].indexOf(selectedFile?.type?.toLowerCase()) < 0
            ) {
                setMsgError(
                    enviroment.limitUpload[
                        IsVideo() ? 'videoErrorFormat' : 'docErrorFormat'
                    ]
                );
            } else {
                setMsgError(enviroment.limitUpload.errorGeneric);
            }

            setSelectedFile(undefined);
            setIsSelected(false);
            resetInputFile();
        }
    };

    const existFile = () => {
        const { urlvideo = '', urldeclaracionjurada = '' } =
            (userMe as IUserMe) || {};
        const fileName: string = (
            IsVideo() ? urlvideo : urldeclaracionjurada
        ) as string;
        const exist: boolean = !!fileName;
        const shortFileName: string =
            fileName?.split('/')[fileName?.split('/').length - 1];

        return {
            exist,
            fileName,
            shortFileName,
        };
    };

    const handleClickButton = () => {
        fileInput?.current.click();
    };

    const resetInputFile = () => {
        if (fileInput?.current) {
            fileInput.current.value = '';
        }
    };

    const removeCharge = () => {
        saveUploaded('', async () => {
            let userMeUpdated = (userMe as IUserMe) || {};
            userMeUpdated[IsVideo() ? 'urlvideo' : 'urldeclaracionjurada'] = '';
            await setUserMe({ ...userMe, ...userMeUpdated });
            setProgress(0);
            setUploaded(false);
            setSelectedFile(undefined);
            setMsgError('');
            resetInputFile();
        });
    };

    const IsVideo = (): boolean => type === 'video';

    const saveUploaded = (filePath: string = '', cb?: Function) => {
        changeIsLoading(true);
        HttpAxios.put(enviroment.apiURL + '/user/me', {
            ...(IsVideo()
                ? { urlvideo: filePath }
                : { urldeclaracionjurada: filePath }),
        })
            .then((res: any) => {
                const { err } = res?.data || {};
                if (err) {
                    setUploaded(false);
                    setMsgError(enviroment.limitUpload.errorGeneric);
                    changeIsLoading(false);
                    setSelectedFile(undefined);
                    setProgress(0);
                } else {
                    setMsgError('');
                    cb && cb();
                    changeIsLoading(false);
                }
            })
            .catch(() => {
                setUploaded(false);
                setMsgError(enviroment.limitUpload.errorGeneric);
                changeIsLoading(false);
            });
    };

    const goOutFileName = (fileName: string) => {
        window.open(fileName, '_blank');
    };

    useEffect(() => {
        try {
            selectedFile && handleSubmission();
        } catch (err) {}
    }, [selectedFile]);

    return (
        <>
            {existFile().exist ? (
                <>
                    <p className="small thelp">
                        {IsVideo() ? 'Video adjuntado' : 'Documento adjuntado'}.
                    </p>
                    <div className="UploadMsg">
                        <span
                            className="UploadMsgText Link"
                            onClick={() => goOutFileName(existFile().fileName)}
                        >
                            {existFile().shortFileName}
                        </span>
                        <img
                            onClick={removeCharge}
                            className="UploadIconClose"
                            src={IconClose}
                            alt=""
                        />
                    </div>
                </>
            ) : (
                <>
                    {!IsVideo() && (
                        <label className="label">
                            Una vez que tengas el documento listo, súbelo aquí
                        </label>
                    )}
                    {progress <= 0 && (
                        <button
                            type="button"
                            className="button buttonLink"
                            onClick={handleClickButton}
                        >
                            <img
                                className="buttonIconLeft"
                                src={IconAttach}
                                alt=""
                            />
                            Adjuntar archivo
                        </button>
                    )}
                    {IsVideo() ? (
                        <p className="small thelp">
                            Adjunta un video de no más de{' '}
                            <strong>{enviroment.limitUpload.videoTime}</strong>,
                            que muestre la iniciativa o estrategia que quieran
                            postular, a las personas que impacta, o lo que
                            quieran mostrarnos al respecto. Asegúrate de que no
                            pese más de{' '}
                            <strong>
                                {enviroment.limitUpload.videoWeight}
                            </strong>{' '}
                            y que tenga alguno de los siguientes formatos{' '}
                            {enviroment.limitUpload.videoAllowFormats}
                        </p>
                    ) : (
                        <p className="small thelp">
                            Solo se admiten archivos en formato .pdf, .doc,
                            .docx y .zip.
                        </p>
                    )}

                    {selectedFile && (
                        <div className="UploadMsg">
                            {!msgError && !uploaded && (
                                <span className="spinner spinnerSmall UploadMsgSpinner"></span>
                            )}
                            <span
                                style={{ width: progress + '%' }}
                                className="UploadMsgBar"
                            ></span>
                            {uploaded ? (
                                <span
                                    className="UploadMsgText Link"
                                    onClick={() =>
                                        goOutFileName(existFile().fileName)
                                    }
                                >
                                    {existFile().shortFileName}
                                </span>
                            ) : (
                                <span className="UploadMsgText">
                                    {nameUploaded || ''}
                                </span>
                            )}
                            {msgError ||
                                (uploaded && (
                                    <img
                                        onClick={removeCharge}
                                        className="UploadIconClose"
                                        src={IconClose}
                                        alt=""
                                    />
                                ))}
                        </div>
                    )}

                    {msgError && (
                        <div className="UploadError helpText invalid">
                            {msgError}
                        </div>
                    )}
                    {uploaded && (
                        <div className="UploadError helpText valid">
                            {
                                enviroment.limitUpload[
                                    IsVideo() ? 'successVideo' : 'successDoc'
                                ]
                            }
                        </div>
                    )}
                    <input
                        className="UploadHide"
                        ref={fileInput}
                        type="file"
                        name="file"
                        onChange={changeHandler}
                        disabled={progress > 0}
                        accept={
                            IsVideo() ? 'video/*' : '.zip, .pdf, .doc, .docx'
                        }
                    />
                </>
            )}
        </>
    );
};

export default Upload;
